<template>
  <div class="d-flex flex-row align-items-center">
    <CContainer>
      <div class="col-12 col-lg-8 mx-auto mt-3 mb-sm-5 mb-3">
        <h4 class="text-center mb-4">設定内容を入力してください</h4>
        <div class="multisteps-form__progress">
          <button
            class="multisteps-form__progress-btn"
            type="button"
            title="STEP1"
          >
            <div class="font-weight-bolder">STEP1</div>
            オプション選択
          </button>
          <button
            class="multisteps-form__progress-btn js-active"
            type="button"
            title="STEP2"
          >
            <span>
              <div class="font-weight-bolder">STEP2</div>
              チャットボット設定
            </span>
          </button>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <CCard>
            <CCardBody>
              <div class="form-group">
                <label class="form-label" for="bot-name-input"
                  >チャットボット名</label
                >
                <div class="input-group">
                  <input
                    id="bot-name-input"
                    type="text"
                    v-model="botName"
                    class="form-control py-4"
                    placeholder="チャットボット名を入力してください"
                  />
                </div>
              </div>
              <div class="form-group">
                <template v-if="botType === 'file' || botType === 'audio'">
                  <label class="form-label" for="file-upload">
                    アップロードファイル
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    @change="handleFileUpload"
                    class="form-control"
                    :accept="selectFileTypes"
                    multiple
                  />
                  <div
                    class="chatbot-step2__upload-area bg-gray-200 border-radius-lg mt-3"
                  >
                    <div v-if="!selectedFiles && botType === 'file'">
                      <p class="font-weight-bolder">
                        ご希望のファイルを選択してください。<br />
                        アップロード可能なファイル形式は以下です。
                      </p>
                      <div class="two-column-list">
                        <ul>
                          <li>Word (.docx)</li>
                          <li>Powerpoint (.pptx)</li>
                          <li>Excel (.xlsx)</li>
                          <li>HTML (.html)</li>
                          <li>JPG (.jpg, .jpeg)</li>
                          <li>Emails (.msg)</li>
                        </ul>
                        <ul>
                          <li>Text (.txt)</li>
                          <li>CSV (.csv)</li>
                          <li>PDF (.pdf)</li>
                          <li>Markdown (.md)</li>
                          <li>Images (.png, .svg)</li>
                        </ul>
                      </div>
                    </div>
                    <div v-if="!selectedFiles && botType === 'audio'">
                      <p class="font-weight-bolder">
                        ご希望のファイルを選択してください。<br />
                        アップロード可能なファイル形式は以下です。
                      </p>
                      <div class="two-column-list">
                        <ul>
                          <li>M4A - Apple Lossless Audio Codec (.m4a)</li>
                          <li>MP3 - MPEG Audio Layer III (.mp3)</li>
                          <li>WEBM - WebM Audiovisual Media (.webm)</li>
                          <li>MP4 - MPEG-4 Part 14 (.mp4)</li>
                          <li>MPGA - MPEG Audio Stream (.mpga)</li>
                          <li>WAV - Waveform Audio File Format (.wav)</li>
                          <li>MPEG - Moving Picture Experts Group (.mpeg)</li>
                          <li>MOV - QuickTime File Format (.mov)</li>
                          <li>FLAC - Free Lossless Audio Codec (.flac)</li>
                        </ul>
                      </div>
                    </div>

                    <div
                      style="text-align: left"
                      v-if="selectedFiles && selectedFiles.length > 0"
                    >
                      <Strong>選択中のファイル:</Strong>
                      <ul>
                        <li v-for="file in selectedFiles" :key="file.name">
                          {{ file.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
                <br />
                <div v-if="botType === 'audio'" class="mb-2">
                  <Strong>OR</Strong>
                </div>
                <template v-if="botType === 'web' || botType === 'audio'">
                  <label class="form-label" for="url-input">{{
                    botType === 'web' ? 'WebサイトのURL' : 'YoutubeのURL'
                  }}</label>
                  <input
                    id="url-input"
                    type="text"
                    v-model="url"
                    class="form-control py-4"
                    @input="clearSelectedFiles"
                    placeholder="サイトのURLを入力してください"
                  />
                  <label class="form-label" for="url-input">{{
                    botType === 'web' ? 'サイト階層' : 'YoutubeのURL'
                  }}</label>
                  <input
                    id="url-input"
                    type="number"
                    v-model="max_level_get_url"
                    class="form-control py-4"
                    @input="clearSelectedFiles"
                    placeholder="サイトの階層数を入力してください"
                  />
                </template>
              </div>
            </CCardBody>
          </CCard>
          <div class="text-center mt-4">
            <button
              @click="goToStep1()"
              class="btn bg-gradient-secondary mb-0 me-4"
            >
              <i class="fas fa-undo-alt me-1"></i> 戻る
            </button>
            <button
              @click="openModal"
              class="btn bg-gradient-warning mb-0 px-4"
              :disabled="shouldDisableButton"
            >
              <i class="fas fa-magic me-1"></i>
              <template v-if="isCreatingChatbot"> 作成中 ... </template>
              <template v-else>
                {{ this.bot_id ? '更新' : '作成' }}
              </template>
            </button>
            <div class="loading-icon-wrapper">
              <template v-if="isCreatingChatbot">
                <img
                  src="../../public/images/loading.gif"
                  alt="Creating Chatbot..."
                  class="loading-icon"
                />
              </template>
            </div>
          </div>

          <div v-if="showConfirmation" class="text-center mt-4">
            <p>Chatbot will be processed.</p>
            <button @click="routeToDashboard" class="btn btn-info white-text">
              OK
            </button>
          </div>
        </div>
        <!-- Add the modal markup -->
        <CModal
          alignment="center"
          scrollable
          :visible="showModal"
          @close="
            () => {
              showModal = false
            }
          "
        >
          <CModalHeader>
            <CModalTitle>Webサイトページ一覧</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div v-if="urls.length === 0">
              <span class="badge badge-info text-start text-sm w-100 py-3">
                WebサイトのURLを取得しています。<br />
                Webサイトの規模によっては時間がかかる場合があります。<br />
                しばらくお待ちください。
              </span>
            </div>
            <div v-else class="modal-scrollable">
              <div class="table-container">
                <table class="url-table">
                  <thead>
                    <tr>
                      <th>選択</th>
                      <th>ページURL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width: 10%">
                        <input
                          type="checkbox"
                          id="select-all"
                          v-model="selectAll"
                          @change="toggleSelectAll"
                        />
                      </td>
                      <td>
                        <label for="select-all"
                          ><strong>全ページ</strong></label
                        >
                      </td>
                    </tr>
                    <tr v-for="url in urls" :key="url">
                      <td style="width: 10%">
                        <input
                          type="checkbox"
                          :id="url"
                          v-model="selectedUrls"
                          :value="url"
                        />
                      </td>
                      <td>{{ url }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </CModalBody>
          <CModalFooter>
            <div class="d-flex justify-content-center w-100">
              <button
                class="btn bg-gradient-secondary mb-0 me-3"
                @click="closeModal"
              >
                <i class="fas fa-times me-1"></i> 閉じる
              </button>
              <button
                class="btn bg-gradient-warning mb-0"
                :disabled="selectedUrls.length === 0"
                @click="createChatbot"
              >
                <i class="fas fa-clipboard-check me-1"></i> 保 存
              </button>
            </div>
          </CModalFooter>
        </CModal>
        <!-- End of modal markup -->
        <div v-if="showErrorPopup" class="popup">
          <div class="popup-content">
            <p>{{ errorMessage }}</p>
            <div class="popup-buttons">
              <button
                v-if="planerror"
                @click="navigateToPricingPage"
                class="btn btn-info white-text"
              >
                Manage Plan
              </button>
              <button @click="cancel" class="btn btn-info white-text">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
  </div>
  <ProcessingOverlay :show="isProcessing" />
</template>
<script>
import HTTPService from '../services/HTTPService'
import { CContainer } from '@coreui/vue'
import { NAV_MASTER } from '@/constants/navMaster'
import ProcessingOverlay from '@/components/ProcessingOverlay.vue'
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
} from '@coreui/vue'
import { getTenantId } from '@/constants/tenants'

export default {
  name: 'ChatbotStep2',
  components: {
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    ProcessingOverlay,
    CContainer,
  },
  props: {
    botType: {
      type: String,
      required: true,
    },
    bot_id: {
      type: String,
      required: false,
    },
    chatbot_name: {
      type: String,
      required: false,
    },
  },
  computed: {
    shouldDisableButton() {
      return (
        this.isCreatingChatbot ||
        this.botName === '' ||
        (this.url === '' && !this.selectedFiles)
      )
    },
    selectFileTypes() {
      if (this.botType == 'file') {
        return '.docx,.pptx,.xlsx,.html,.jpg, .jpeg, .csv, .txt, .pdf, .md, .png, .svg, .msg'
      }
      if (this.botType == 'audio') {
        return '.m4a, .mp3, .webm, .mp4, .mpga, .wav, .mpeg, .flac, .mov'
      }
      return ''
    },
  },
  data() {
    return {
      selectedFiles: null,
      botName: '',
      url: '',
      showConfirmation: false,
      isCreatingChatbot: false,
      errorMessage: '',
      showErrorPopup: false,
      showModal: false,
      urls: [],
      selectedUrls: [],
      modalmessage:
        'Retrieving URLs...<br>Depending on how large the site is, this may take a while so please be patient!',
      planerror: false,
      selectAll: false,
      isProcessing: false,
      max_level_get_url: 1,
    }
  },
  created() {
    //console.log(this.botType === 'file')
    //console.log(this.chatbot_name)
    if (this.chatbot_name) {
      this.botName = this.chatbot_name
    }
  },
  methods: {
    goToStep1() {
      this.$emit('change-active-component', {
        component: 'ChatbotStep1',
        params: {
          bot_id: this.bot_id,
          chatbot_name: this.chatbot_name,
        },
      })
    },
    handleFileUpload(event) {
      const files = event.target.files
      const maxSize = 50 * 1024 * 1024 // 50MB in bytes

      for (let i = 0; i < files.length; i++) {
        const file = files[i]

        if (file.size > maxSize) {
          alert(
            `「${file.name}」はファイルサイズが大きすぎます。 1ファイル50MBまでとなります。`,
          )
          // Clear the input value to allow selecting a new file
          event.target.value = ''
          return
        }
      }

      this.selectedFiles = event.target.files
      // Use the selected files as needed
      console.log(this.selectedFiles)
    },
    openModal() {
      if (this.botType === 'web') {
        this.urls = []
        this.selectedUrls = []
        this.showModal = true
        this.modalmessage =
          'Retrieving URLs...<br>Depending on how large the site is, this may take a while so please be patient!'
        this.getUrls()
      } else {
        this.createChatbot()
      }
    },
    getUrls() {
      // get the url from the text input

      HTTPService.get_url(this.url, this.max_level_get_url)
        .then((response) => {
          //console.log(response.data)
          if (!response.data.urls || response.data.urls.length === 0) {
            this.modalmessage =
              'Failed to retrieve URLs, please check the url "' +
              this.url +
              '" is correct and try again'
          } else {
            this.urls = response.data.urls.sort()
          }
        })
        .catch((error) => {
          console.error(error)
          this.modalmessage =
            'Failed to retrieve URLs, please check the url "' +
            this.url +
            '" is correct and try again'
        })
    },
    closeModal() {
      this.showModal = false
    },
    createChatbot() {
      this.showModal = false
      const formData = new FormData()
      if (this.botType === 'file' && this.selectedFiles) {
        for (let i = 0; i < this.selectedFiles.length; i++) {
          formData.append('files[]', this.selectedFiles[i])
        }
      }
      if (this.botType === 'web') {
        formData.append('url', JSON.stringify(this.selectedUrls))
      }
      if (this.botType === 'audio') {
        if (this.url.length > 0) {
          formData.append('url', JSON.stringify([this.url]))
        }
        if (this.selectedFiles) {
          for (let i = 0; i < this.selectedFiles.length; i++) {
            formData.append('files[]', this.selectedFiles[i])
          }
        }
      }
      if (this.botName) {
        formData.append('data', JSON.stringify({ bot_name: this.botName }))
      }
      if (this.bot_id) {
        formData.append('bot_id', this.bot_id)
      }

      // RAGっチャオ
      formData.append('nav_id', NAV_MASTER.RAG_CHAT)

      formData.append('tenant_id', getTenantId(this.$route))

      //this.isCreatingChatbot = true
      this.isProcessing = true

      HTTPService.createChatbot(formData)
        //.then((response) => {
        .then(() => {
          //console.log(response.data)
          //this.showConfirmation = true
          //let bot_id = response.data.bot_id
          //this.routeToDashboard(bot_id)
          //this.$store.commit('updateInitBotId', bot_id)
          //this.$router.push({
          //  name: 'ChatBotSetting',
          //})
          window.location.reload()
        })
        .catch((error) => {
          console.error(error)
          if (error.response && error.response.data.error) {
            this.errorMessage = error.response.data.error
            this.showErrorPopup = true
            if (
              error.response &&
              (error.response.status === 423 || error.response.status === 424)
            ) {
              this.planerror = true
            }
          } else {
            this.errorMessage = 'Failed to create chatbot: ' + error.response
            this.showErrorPopup = true
          }
        })
        .finally(() => {
          //this.isCreatingChatbot = false
          this.isProcessing = false
        })
    },
    routeToDashboard(bot_id) {
      this.$emit('change-active-component', {
        component: 'Chatbot',
        params: { bot_id: bot_id },
      })
    },
    navigateToPricingPage() {
      this.$emit('change-active-component', {
        component: 'Pricing',
      })
    },
    cancel() {
      this.showErrorPopup = false
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Select all URLs
        this.selectedUrls = this.urls.slice()
      } else {
        // Deselect all URLs
        this.selectedUrls = []
      }
    },
  },
}
</script>

<style scoped>
.chatbot-step2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.chatbot-step2__form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chatbot-step2__label {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.chatbot-step2__input {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
}

.chatbot-step2__input input {
  width: 80%;
  padding: 0.5rem;
  font-size: 1.2rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.chatbot-step2__file-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chatbot-step2__upload-area {
  margin-top: 1rem;
  border: 1px dashed #ccc;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
}

.chatbot-step2__create-button {
  margin-top: 2rem;
  font-size: 1.2rem;
  padding: 1rem 2rem;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}

.c-dropzone {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  border: 2px dashed #ccc;
  border-radius: 5px;
  transition: border-color 0.3s ease;
}

.c-dropzone__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
  color: #ccc;
}

.c-dropzone:hover {
  border-color: #0c2231;
}

.c-dropzone--dragging {
  border-color: #0c2231;
}

.loading-icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  vertical-align: middle;
  background-color: transparent;
}

.loading-icon-wrapper {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 400px;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.modal-half-width {
  width: 50%; /* Adjust the width as needed */
}

.modal-scrollable {
  max-height: 300px; /* Adjust the maximum height as needed */
  overflow-y: auto;
}

.table-container {
  margin-top: 10px; /* Adjust the margin as needed */
}

.url-table {
  width: 100%;
  border-collapse: collapse;
}

.url-table th,
.url-table td {
  padding: 8px;
  border: 1px solid #ccc;
}

.url-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 400px; /* adjust the width as needed */
}

.popup-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.two-column-list {
  display: flex;
  justify-content: center;
}

.two-column-list ul {
  list-style-type: disc; /* Add this line to display bullet points */
  padding-left: 0;
  text-align: left; /* Center the text within each list item */
}

.two-column-list ul:first-child {
  margin-right: 100px; /* Add right margin to create padding between columns */
}

.white-text {
  color: white;
}
</style>
